import WithFormsyMarkupTextInput, { MarkupTextInput } from './MarkupTextInput';

export { MarkupTextInput };
export default WithFormsyMarkupTextInput;
